import {External, M} from "../../external";
import {
  validateSMSMessage,
  validateVoiceMessage,
  validateWhatsAppMessage
} from "../../CRM/Popups/messages/common";

export const SMS = 4;
export const WHATSAPP = 5;
export const VOICE = 6;

export function getSubscribers(data, onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getCampaignAudience",
    data: {
      lists: JSON.stringify(data.lists),
      segments: JSON.stringify(data.segments)
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }
      onDone(response.data);
    }
  });
}

export function getLists(onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getMarketingLists",
    data: {
      withStats: false
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }

      onDone(response.data);
    }
  });
}

export function getSegments(onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getMarketingSegments",
    data: {
      withStats: false,
      withSubscriberCount: true
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }

      onDone(response.data);
    }
  });
}

export function validate(step, data) {
  return {
    name: function () {
      if (!data.name) {
        External.Tools.showError(M.INSERT_CAMPAIGN_NAME);
        return false;
      }
      return true;
    },
    type: function () {
      if (!data.type) {
        External.Tools.showError(M.SELECT_CAMPAIGN_TYPE);
        return false;
      }
      return true;
    },
    recipients: function () {
      if (data.data.lists.length === 0 && data.data.segments.length === 0) {
        External.Tools.showError(M.SELECT_LIST_SEGMENT);
        return false;
      }
      return true;
    },
    summary: function () {
      try {
        return validateMessageSettings(data);
      } catch (e) {
        External.Tools.showError(e);
        return false;
      }
    },
    send: function () {
      return true;
    }
  }[step]();
}

function validateMessageSettings(data) {
  if (!External.Website.isMessagingEnabled()) {
    throw M.PLEASE_CONNECT_TWILIO;
  }
  if (data.data.salesUtm && !data.data.salesUtm.campaign?.length) {
    throw M.INVALID_UTM_CAMPAIGN;
  }

  const message = data.content;

  if (data.type === WHATSAPP){
    if (message.templateRejected) {
      throw M.TEMPLATE_REJECTED + message.rejectionReason;
    }
    validateWhatsAppMessage(message);
  } else if (data.type === SMS) {
    validateSMSMessage(message);
  } else if (data.type === VOICE) {
    validateVoiceMessage(message);
  }
  return true;
}
